module.exports = __webpack_public_path__ + "media/antarctic_circle.dafcb47c.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/resources/vector/grid/antarctic_circle.geojson
// module id = 1116
// module chunks = 0